import Header from "@/components/landing/Header";
import SEOHead from "@/components/SEOHead";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import ProblemSection from "@/components/landing/ProblemSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import Testimonials from "@/components/landing/Testimonials";
import Pricing from "@/components/landing/Pricing";
import FAQSection from "@/components/landing/FAQSection";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import { useScrollDepth } from "@/hooks/useScrollDepth";
import { SectionTracker } from "@/components/landing/SectionTracker";

const Index = () => {
  // Track scroll depth
  useScrollDepth();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Immovox | IA téléphonique pour agences immobilières"
        description="Immovox répond aux appels des agences immobilières, qualifie la demande et transmet une synthèse exploitable quand l’équipe ne peut pas décrocher."
        canonical="/"
      />
      <Header />
      <main>
        <SectionTracker name="hero">
          <Hero />
        </SectionTracker>
        <SectionTracker name="trust_bar">
          <TrustBar />
        </SectionTracker>
        <SectionTracker name="problem">
          <ProblemSection />
        </SectionTracker>
        <SectionTracker name="how_it_works">
          <HowItWorksSection />
        </SectionTracker>
        <SectionTracker name="features">
          <FeaturesSection />
        </SectionTracker>
        <SectionTracker name="testimonials">
          <Testimonials />
        </SectionTracker>
        <SectionTracker name="pricing">
          <Pricing />
        </SectionTracker>
        <SectionTracker name="faq">
          <FAQSection />
        </SectionTracker>
        <SectionTracker name="cta">
          <CTA />
        </SectionTracker>
      </main>
      <Footer />
      <ExitIntentPopup />
    </div>
  );
};

export default Index;
